import { ClbButton } from '@celebration/react/ClbButton/ClbButton';
import { ClbTooltip } from '@celebration/react/ClbTooltip/ClbTooltip';
import { ClbInputSearch } from '@celebration/react/ClbInputSearch/ClbInputSearch';
import IToolbarProps from './interfaces/IToolbarProps';
import Auth from '../../../../app/contexts/auth';
import { SULAHUB_ROLES } from '../../../../common/constants/roles';
import CarrierFormFullPageFlow from '../carrier-form/carrier-form';
import i18n from '../../../../lib/i18n';

function Toolbar({
    anyCarrierChecked,
    description,
    setDescriptionCallback,
    toggleShowFiltersCallback,
    confirmCarriersDeleteCallback,
    isCarrierFormOpened,
    setIsCarrierFormOpened,
    setEditCarrierId,
    carrierId,
}: Readonly<IToolbarProps>) {
    const { isAuthorized } = Auth.useAuth();

    return (
        <div className="carriers-toolbar">
            <ClbInputSearch
                className="search-carrier-input"
                name="search-carrier"
                placeholder={i18n.t('Pesquisar')}
                value={description}
                onChange={(e: any) => {
                    setDescriptionCallback(e.target.value);
                }}
                data-testid="carrier-input-search"
            />

            <div className="carriers-toolbar-actions">
                {isAuthorized([
                    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
                ]) && (
                    <ClbTooltip
                        position="bottom"
                        colorMode="dark"
                        description={i18n.t('Excluir')}
                    >
                        <ClbButton
                            size="md"
                            icon="delete"
                            styleType="icon"
                            disabled={!anyCarrierChecked}
                            onClick={() =>
                                anyCarrierChecked &&
                                confirmCarriersDeleteCallback()
                            }
                            data-testid="carrier-delete-icon"
                        />
                    </ClbTooltip>
                )}

                <ClbTooltip
                    position="bottom"
                    colorMode="dark"
                    description={i18n.t('Filtrar')}
                >
                    <ClbButton
                        size="md"
                        icon="filter"
                        styleType="icon"
                        onClick={() => toggleShowFiltersCallback()}
                        data-testid="carrier-filter-icon"
                    />
                </ClbTooltip>

                {isAuthorized([
                    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
                ]) && (
                    <ClbButton
                        styleType="primary"
                        onClick={() => setIsCarrierFormOpened(true)}
                        data-testid="carrier-add-button"
                        label={i18n.t('NovaTransportadora')}
                        size="md"
                    />
                )}

                {isAuthorized([
                    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
                ]) && (
                    <CarrierFormFullPageFlow
                        isCarrierFormOpened={isCarrierFormOpened}
                        setIsCarrierFormOpened={setIsCarrierFormOpened}
                        setCarrierId={setEditCarrierId}
                        carrierId={carrierId}
                    />
                )}
            </div>
        </div>
    );
}

export default Toolbar;
